module.exports = __webpack_public_path__ + "images/blackout_bingo_phone-0446a3fa47e427fc8564adb364e64908.png";